import {fetchSync} from '@shopify/hydrogen';
import {useState} from 'react';

export default function NotifyBackInStock({variantId, onClose}) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  console.log('Variant ID: ', variantId);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Call the API route you'll create
    const response = await fetch(`/api/subscribe-back-in-stock`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({email, variantId}),
    });

    if (response.ok) {
      console.log('Subscription successful');
      console.log('Form Data: ', response);
      onClose();
      // Optionally, clear the form or show a success message
    } else {
      const responseData = await response.json();
      setError(responseData.message || 'Server error, Subscription failed');
      console.error('Server error, Subscription failed');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="notify-form">
      <h4>Notify me when this item is back in stock</h4>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email"
        required
      />
      {error && <p className="error-message">{error}</p>}
      <button type="submit" className="btn btn--reverse">
        Notify me!
      </button>
    </form>
  );
}
